import React, { forwardRef } from "react";
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { formatDateTimeForTextField } from "src/utils/dateUtils";

type Props = TextFieldProps & {
  value?: string | null;
  onChange: (value?: string | null) => void;
};

// eslint-disable-next-line react/display-name
const DateTimeTextField = forwardRef<HTMLDivElement, Props>((props, ref) => {
  return (
    <TextField
      type="datetime-local"
      variant="outlined"
      ref={ref}
      {...props}
      value={formatDateTimeForTextField(props.value)}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        style: { paddingRight: 0 },
        endAdornment: (
          <InputAdornment position="end" style={{ margin: 0 }}>
            <IconButton
              aria-label="Clear"
              onClick={() => props.onChange(null)}
              disabled={!props.value}
            >
              <CloseIcon />
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
});

export default DateTimeTextField;
